import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@ngneat/transloco';
import { RedPaginationModule } from '@red/components/pagination';
import { SelectSearchModule } from '@red/components/select-search';
import { FindModule } from '@red/pipes/find';
import { LoadingBoxModule } from '@shared/components/loading-box';
import { TableActionGroupModule } from '@shared/components/table-action-group';
import { PermissionModule } from '@shared/permission';
import { ToastModule } from '@shared/components/toast';
import { ConfirmDialogModule } from '@shared/components/confirm-dialog';
import { BreadcrumbModule } from '@shared/components/breadcrumb';
import { VirtualScrollControllerModule } from '@shared/components/virtual-scroll-controller';
import { DynamicReportGeneralDetailComponent } from './dynamic-report-general-detail.component';
import { DynamicReportGeneralFormModule } from '../dynamic-report-general-form/dynamic-report-general-form.module';
import { DynamicReportGeneralDetailRoutingModule } from './dynamic-report-general-detail-routing.module';
import { LastUpdatedInformationModule } from '@shared/components/last-updated-information';

const angularMaterialModules = [
    MatIconModule,
    MatTableModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatButtonModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatMenuModule,
    MatDividerModule
];

const redModules = [
    RedPaginationModule,
    SelectSearchModule,
    FindModule,
];

const sharedComponentModules = [
    LoadingBoxModule,
    TableActionGroupModule,
    ToastModule,
    ConfirmDialogModule,
    BreadcrumbModule,
    VirtualScrollControllerModule,
    DynamicReportGeneralFormModule,
    LastUpdatedInformationModule
];

@NgModule({
    declarations: [DynamicReportGeneralDetailComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ...angularMaterialModules,
        ...redModules,
        ...sharedComponentModules,
        DynamicReportGeneralDetailRoutingModule,
        TranslocoModule,
        PermissionModule,
    ],
    exports: [DynamicReportGeneralDetailComponent],
})
export class DynamicReportGeneralDetailModule { } 